import _extends from "@babel/runtime/helpers/extends";
import _jsx from "@babel/runtime/helpers/jsx";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
var _excluded = ["item", "disableHover", "className", "classes", "intl", "lang", "inOneColumn", "searchSessionId"];
var _dec, _dec2, _dec3, _class, _class2;
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
import React, { Component } from 'react';
import { defineMessages, FormattedMessage, injectIntl } from 'react-intl';
import PropTypes from 'prop-types';
import _ from 'lodash';
import classNames from 'classnames';
import withStyles from 'isomorphic-style-loader/withStyles';
import { connect } from 'react-redux';
import Paper from '@mui/material/Paper';
import ButtonBase from '@mui/material/ButtonBase';
import Typography from '@mui/material/Typography';
import Modal from '@mui/material/Modal';
import LinearProgress from '@mui/material/LinearProgress';
import Tooltip from '@mui/material/Tooltip';
import muiWithStyles from '@mui/styles/withStyles';
import { Interweave } from 'interweave';
import { buildQuery, handleErroredImage } from '../../helpers';
import isLoggedIn from '../../helpers/checkAuth';
import Link from '../Link';
import RestrictedAccessModal from '../RestrictedAccessModal/RestrictedAccessModal';
import AppContext from '../../context';
import s from './LessonItem.scss';
import intlPropTypes from '../../constants/intlPropTypes';
var messages = defineMessages({
  timeText: {
    id: "LessonItem.timeText",
    defaultMessage: [{
      "type": 1,
      "value": "minutes"
    }, {
      "type": 0,
      "value": " min"
    }]
  },
  noAccess: {
    id: "LessonItem.noAccess",
    defaultMessage: [{
      "type": 0,
      "value": "You don’t have access to this content yet"
    }]
  },
  typeLesson: {
    id: "Courses.typeLesson",
    defaultMessage: [{
      "type": 0,
      "value": "Lesson"
    }]
  }
});
var styles = function styles(theme) {
  return {
    courseProgressRoot: {
      backgroundColor: '#F6F6F7',
      position: 'absolute',
      bottom: 0,
      width: '100%'
    },
    courseProgressBar: {
      backgroundColor: _.get(theme.palette.primary.light)
    }
  };
};
var LessonItem = (_dec = withStyles(s), _dec2 = muiWithStyles(styles), _dec3 = connect(function (state) {
  return {
    auth: state.auth,
    lang: state.intl.locale
  };
}), injectIntl(_class = _dec(_class = _dec2(_class = _dec3(_class = (_class2 = /*#__PURE__*/function (_Component) {
  _inherits(LessonItem, _Component);
  var _super = _createSuper(LessonItem);
  function LessonItem() {
    var _this;
    _classCallCheck(this, LessonItem);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized(_this), "state", {
      isRestrictedAccessModalOpened: false
    });
    _defineProperty(_assertThisInitialized(_this), "checkAuth", function (event) {
      var _this$props = _this.props,
        auth = _this$props.auth,
        item = _this$props.item;
      if (item.isGloballyFree || isLoggedIn(auth) && item.isAvailable) {
        return;
      }
      event.preventDefault();
      event.stopPropagation();
      _this.setState({
        isRestrictedAccessModalOpened: true
      });
    });
    _defineProperty(_assertThisInitialized(_this), "closeRestrictedAccessModal", function () {
      _this.setState({
        isRestrictedAccessModalOpened: false
      });
    });
    return _this;
  }
  _createClass(LessonItem, [{
    key: "render",
    value: function render() {
      var _classNames5;
      var _this$props2 = this.props,
        item = _this$props2.item,
        disableHover = _this$props2.disableHover,
        className = _this$props2.className,
        classes = _this$props2.classes,
        formatMessage = _this$props2.intl.formatMessage,
        lang = _this$props2.lang,
        inOneColumn = _this$props2.inOneColumn,
        searchSessionId = _this$props2.searchSessionId,
        rest = _objectWithoutProperties(_this$props2, _excluded);
      var isRestrictedAccessModalOpened = this.state.isRestrictedAccessModalOpened;
      var timeSeconds = (item.time || 0) % 60;
      var timeMinutes = ((item.time || 0) - timeSeconds) / 60;
      return /*#__PURE__*/_jsx(Tooltip, {
        placement: "top",
        title: !item.isAvailable ? formatMessage(messages.noAccess) : item.name
      }, void 0, /*#__PURE__*/React.createElement(Paper, _extends({
        className: classNames(s.lessonItem, disableHover && s.disableHover, !item.isAvailable && s.addonLesson, className)
      }, rest, {
        "data-test": "lesson-item",
        "data-test-value": item.name
      }), /*#__PURE__*/_jsx(ButtonBase, {
        "data-test-id": "wo-E24XFDrTKr03QjK52C",
        component: Link,
        to: "/lessons/".concat(item.slug, "?").concat(buildQuery({
          searchSessionId: searchSessionId
        })),
        onClick: this.checkAuth,
        className: classNames(s.lessonItemLink, _defineProperty({}, s.inOneColumn, inOneColumn)),
        focusRipple: true
      }, void 0, /*#__PURE__*/_jsx("img", {
        src: "".concat(this.context.cloudfrontUrl, "/default-lesson-preview.jpeg"),
        alt: item.name,
        title: item.name,
        className: classNames(s.lessonItemImage, _defineProperty({}, s.inOneColumn, inOneColumn)),
        onError: handleErroredImage
      }), /*#__PURE__*/_jsx("div", {
        className: classNames(s.lessonItemTextDataWrapper, _defineProperty({}, s.inOneColumn, inOneColumn))
      }, void 0, /*#__PURE__*/_jsx(Typography, {
        className: s.itemType
      }, void 0, _.toUpper(formatMessage(messages.typeLesson))), /*#__PURE__*/_jsx(Typography, {
        variant: "subtitle1",
        className: classNames(s.lessonItemTitle, _defineProperty({}, s.inOneColumn, inOneColumn)),
        "data-test": "lesson-name"
      }, void 0, /*#__PURE__*/_jsx(Interweave, {
        content: item.name,
        tagName: "div",
        className: classNames(s.lessonItemTitleHTMLContent, (_classNames5 = {}, _defineProperty(_classNames5, s.inOneLine, inOneColumn), _defineProperty(_classNames5, s.inTwoLine, !inOneColumn), _classNames5))
      })), inOneColumn && /*#__PURE__*/_jsx("div", {
        className: s.description
      }, void 0, /*#__PURE__*/_jsx(Interweave, {
        content: item.shortDescription,
        noWrap: true
      })), /*#__PURE__*/_jsx("div", {
        className: classNames(s.lessonItemDetails, _defineProperty({}, s.inOneColumn, inOneColumn))
      }, void 0, /*#__PURE__*/_jsx(Typography, {
        variant: "subtitle1",
        className: classNames(s.lessonItemDetailsStats, _defineProperty({}, s.inOneColumn, inOneColumn))
      }, void 0, !!timeMinutes && /*#__PURE__*/React.createElement(FormattedMessage, _extends({}, messages.timeText, {
        values: {
          minutes: timeMinutes
        }
      })))))), !!item.isCompleted && /*#__PURE__*/_jsx(LinearProgress, {
        variant: "determinate",
        value: item.isCompleted ? 100 : 0,
        color: "primary",
        classes: {
          root: classes.courseProgressRoot,
          barColorSecondary: classes.courseProgressBar
        }
      }), /*#__PURE__*/_jsx(Modal, {
        open: isRestrictedAccessModalOpened,
        onClose: this.closeRestrictedAccessModal
      }, void 0, /*#__PURE__*/_jsx(RestrictedAccessModal, {
        onClose: this.closeRestrictedAccessModal
      }))));
    }
  }]);
  return LessonItem;
}(Component), _defineProperty(_class2, "defaultProps", {
  disableHover: false,
  className: '',
  searchSessionId: ''
}), _defineProperty(_class2, "contextType", AppContext), _class2)) || _class) || _class) || _class) || _class);
export { LessonItem as default };